var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.5C11.9011 26.5 11.8045 26.4707 11.7222 26.4157C11.64 26.3608 11.5759 26.2827 11.5381 26.1913C11.5002 26.1 11.4903 25.9995 11.5096 25.9025C11.5289 25.8055 11.5765 25.7164 11.6464 25.6464L21.2929 16L11.6464 6.35354C11.5528 6.25974 11.5002 6.1326 11.5003 6.00005C11.5003 5.8675 11.553 5.7404 11.6467 5.64668C11.7405 5.55296 11.8676 5.50029 12.0001 5.50024C12.1327 5.5002 12.2598 5.55279 12.3536 5.64645L22.3536 15.6464C22.4474 15.7402 22.5 15.8674 22.5 16C22.5 16.1326 22.4474 16.2598 22.3536 16.3535L12.3536 26.3535C12.3072 26.4 12.2521 26.4369 12.1914 26.462C12.1307 26.4872 12.0657 26.5001 12 26.5Z",
    fill: "#222229",
    stroke: "#222229",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNew);
export default __webpack_public_path__ + "static/media/arrow-right-new.a9943cfdec09d9a3855cb3f430789b51.svg";
export { ForwardRef as ReactComponent };